const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function fetchAuthenticatedContent({
	endpoint,
	method = "GET",
	body = null,
	headers = null,
	extraParams = {},
}) {
	const auth = new DrupalOAuth();
	const content = await auth.drupalFetch(endpoint, method, body, headers, extraParams);
	if (!content) {
		console.error("bad request was made", endpoint, method, body, headers, extraParams);
	}
	return content;
};
